module.exports = __webpack_public_path__ + "img/orders.f269874a.svg";